{
  "header": {
    "title": "Resumen de la encuesta",
    "description": "Crea, gestiona y analiza encuestas a empleados para obtener información más profunda",
    "createButton": "Crear una encuesta",
    "createModal": {
      "title": "Crear una encuesta",
      "useTemplate": {
        "title": "Usar plantillas",
        "description": "Explora plantillas predefinidas y personalízalas según tus objetivos",
        "buttonLabel": "Ver plantillas"
      },
      "createTemplate": {
        "title": "Crear desde cero",
        "description": "Crea tu encuesta única con el formato que prefieras",
        "buttonLabel": "Crear encuesta"
      }
    },
    "unsavedChangesDialog": {
      "title": "Cambios no guardados en la encuesta",
      "description": "Tienes cambios no guardados que se perderán si abandonas esta página. ¿Quieres continuar sin guardar?",
      "exitButton": "Salir sin guardar",
      "keepEditingButton": "Seguir editando"
    }
  },
  "tabs": {
    "active": "Activas",
    "finished": "Finalizadas",
    "scheduled": "Programadas",
    "drafts": "Borradores"
  },
  "searchInput": {
    "placeholder": "Buscar encuestas"
  },
  "tagsDropdown": {
    "triggerLabel": "Etiquetas",
    "placeholder": "Buscar una etiqueta",
    "options": {
      "employeeEngagement": "Compromiso de empleados",
      "workplaceCulture": "Cultura laboral",
      "teamSatisfaction": "Satisfacción del equipo",
      "performanceFeedback": "Retroalimentación de desempeño",
      "organizationalImprovement": "Mejora organizacional",
      "usa": "EE.UU.",
      "europe": "Europa",
      "asia": "Asia",
      "ukraine": "Ucrania"
    }
  },
  "builderPage": {
    "header": {
      "title": "Constructor de encuestas",
      "backButton": "Volver",
      "seePreviewButton": "Ver vista previa",
      "shareButton": "Compartir",
      "saveButton": {
        "label": "Guardar",
        "options": {
          "draft": "Guardar como borrador",
          "template": "Guardar como plantilla",
          "companyTemplate": "Guardar como plantilla de empresa"
        }
      },
      "publishButton": "Publicar"
    },
    "tabs": {
      "surveySetup": {
        "title": "Configuración de la encuesta",
        "coverImageSection": {
          "title": "Imagen de portada",
          "imageUpload": "Sube una imagen o arrástrala aquí",
          "imageSize": "Máx. 800x400 px",
          "formatImage": "Formato PNG, JPG",
          "titleInput": {
            "label": "Título de la encuesta",
            "placeholder": "Ingresa un título"
          },
          "descriptionInput": {
            "label": "Descripción de la encuesta",
            "placeholder": "Ingresa una descripción"
          },
          "tagsInput": {
            "label": "Etiquetas de la encuesta",
            "placeholder": "Ingresa una etiqueta y presiona enter"
          }
        },
        "question": {
          "title": "Pregunta #{{questionCount}}",
          "required": "Requerido",
          "type": {
            "title": "Tipo de pregunta",
            "textType": "Texto",
            "scaleType": "Escala",
            "choiceType": "Opción"
          },
          "questionInput": {
            "label": "Pregunta",
            "placeholder": "Ingresa la pregunta aquí"
          },
          "descriptionInput": {
            "label": "Descripción de la pregunta",
            "placeholder": "Ingresa la descripción aquí"
          },
          "span": {
            "title": "Rango",
            "to": "a"
          },
          "spanLabels": {
            "title": "Etiquetas del rango",
            "placeholder": "Etiqueta (opcional)"
          },
          "options": {
            "title": "Opciones de elección",
            "placeholder": "Ingresa una opción",
            "addChoiceButton": "Agregar una opción",
            "multipleAnswers": "Respuestas múltiples"
          },
          "addNewQuestionBUtton": "Agregar nueva pregunta"
        },
        "cardPreview": {
          "title": "Vista previa de la tarjeta de encuesta",
          "tabs": {
            "cover": {
              "label": "Portada",
              "time": "1-2 minutos"
            },
            "template": {
              "label": "Plantilla",
              "time": "1-2 minutos"
            }
          }
        }
      },
      "audience": {
        "title": "Audiencia",
        "audienceSection": {
          "title": "Tamaño de la audiencia"
        },
        "surveyAudienceSection": {
          "title": "Audiencia de la encuesta",
          "options": {
            "entireCompany": "Toda la empresa"
          }
        },
        "segmentationSection": {
          "title": "Opciones de segmentación",
          "selectAll": "Seleccionar todo",
          "options": {
            "location": {
              "label": "Ubicación",
              "options": {
                "us": "EE.UU.",
                "europe": "Europa",
                "asia": "Asia"
              }
            },
            "department": {
              "label": "Departamento",
              "options": {
                "executiveTeam": "Equipo ejecutivo",
                "technicalTeam": "Equipo técnico",
                "designTeam": "Equipo de diseño",
                "productTeam": "Equipo de producto",
                "salesTeam": "Equipo de ventas",
                "marketingTeam": "Equipo de marketing",
                "financeTeam": "Equipo financiero"
              }
            },
            "gender": {
              "label": "Género",
              "options": {
                "male": "Masculino",
                "female": "Femenino"
              }
            },
            "tenure": {
              "label": "Antigüedad",
              "options": {
                "lessThanHalf": "<0,5 años",
                "halfToOne": "0,5–1 año",
                "oneToTwo": "1–2 años",
                "twoToFive": "2–5 años",
                "moreThanFive": "Más de 5 años"
              }
            }
          }
        },
        "distributionSection": {
          "title": "Métodos de distribución",
          "options": {
            "mail": "Correo electrónico automatizado",
            "link": "Compartir enlace manualmente"
          }
        }
      },
      "delivery": {
        "title": "Entrega",
        "startDate": {
          "label": "Fecha de inicio",
          "placeholder": "Seleccionar fecha"
        },
        "endDate": {
          "label": "Fecha de fin",
          "closeAfter": "Cerrar después de",
          "days": "días",
          "closeButton": "No cerrar automáticamente"
        }
      },
      "translation": {
        "title": "Traducción",
        "tabs": {
          "info": {
            "label": "Información"
          },
          "question": {
            "label": "Pregunta {{questionCount}}"
          }
        }
      }
    }
  },
  "preview": {
    "header": {
      "backButton": "Vista previa de la encuesta",
      "publishButton": "Publicar"
    },
    "question": {
      "finishSurvey": "Finalizar encuesta",
      "nextQuestion": "Siguiente pregunta",
      "previousQuestion": "Pregunta anterior"
    }
  },
  "detailsPage": {
    "header": {
      "backButton": "Volver al resumen de la encuesta",
      "exportButton": "Exportar"
    },
    "surveyOverviewSection": {
      "title": "Resumen de la encuesta",
      "invitedBlock": {
        "title": "Invitados",
        "usersCount": "{{usersCount}} usuarios"
      },
      "responsesBlock": {
        "title": "Respuestas"
      },
      "info": {
        "creator": "Creador",
        "startDate": "Fecha de inicio",
        "endDate": "Fecha de fin",
        "segmentation": "Segmentación",
        "distributionMethod": "Método de distribución"
      }
    },
    "question": {
      "questionCount": "Pregunta #{{questionCount}}",
      "responseCount": "{{responseCount}} respuestas"
    },
    "asnwersSection": {
      "title": "Respuestas"
    }
  }
}
